module.exports = __webpack_public_path__ + "static/media/shell-box-image.0ff1adef.png";